import { RoomPaymentSchedule } from "redmond/hotels-module/interfaces";
import { CorpRoomProduct, RoomProduct } from "redmond";

export const isAllowedPayLaterLodging = (
  allowedLodgingIds: string[] | undefined,
  lodgingId?: string
): boolean => {
  if (!allowedLodgingIds || allowedLodgingIds.length === 0) {
    return true;
  }

  if (allowedLodgingIds.includes("*")) {
    return true;
  }

  return !!lodgingId && allowedLodgingIds.includes(lodgingId);
};

export const hasPayLaterProducts = (
  products?: (RoomProduct | CorpRoomProduct)[]
) => {
  return !!products?.some(
    (product) => product.roomPaymentSchedule === RoomPaymentSchedule.PayLater
  );
};
